import React from "react";
import { ReferenceAutocompleteInput } from "ra-friendsofbabba";

const ExpertInput = (props) => (
  <ReferenceAutocompleteInput
    {...props}
    reference="users"
    filter={{
      roles: ["expert"],
    }}
    allowEmpty
    emptyText="resources.executive-projects.fields.expert_id.empty"
    optionText="name"
    helperText="resources.executive-projects.fields.expert_id.help"
  />
);
export default ExpertInput;
